// toast-notification.js
class ToastNotification {
  constructor() {
    if (!ToastNotification.instance) {
      ToastNotification.instance = this;
    }
    this.SVGICONS = {
      info: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z" fill="#3B82F6"/>
      </svg>`,
      
      success: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289L9 10.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L8.29289 12.7071C8.68342 13.0976 9.31658 13.0976 9.70711 12.7071L13.7071 8.70711Z" fill="#10B981"/>
      </svg>`,
      
      error: `<svg width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 9v2m0 4v.01" />
      <path d="M10.29 3.86l-7.29 12.64a2 2 0 0 0 1.71 3h14.58a2 2 0 0 0 1.71 -3l-7.29 -12.64a2 2 0 0 0 -3.42 0z" />
      </svg>`,
      
      warning: `<svg width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>`
    };
    
    return ToastNotification.instance;
  }
  // Main method
  show(message, status = 'info', duration = 3000) {
    this.createToast(message,this.SVGICONS.info, status, duration);
  }

  success(message, duration = 3000) {
    this.createToast(message, this.SVGICONS.success, 'success', duration);
  }

  error(message, duration = 4000) {
    this.createToast(message, this.SVGICONS.error, 'error', duration);
  }

  warning(message, duration = 4000) {
    this.createToast(message, this.SVGICONS.warning, 'warning', duration);
  }

  info(message, duration = 3000) {
    this.createToast(message, this.SVGICONS.info, 'info', duration);
  }

  // Internal creator
  createToast(message, icon, status, duration) {
  
    document.querySelectorAll('.toast-notification').forEach(t => t.remove());
    const toast = document.createElement('div');
    toast.className = 'toast-notification';

    toast.innerHTML = `
      <div class="toast-content ${status}">
        <span class="toast-icon">${this.SVGICONS[status] || this.SVGICONS.info}</span>
        <span class="toast-${status}-message">${message}</span>
      </div>
    `;

    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      toast.classList.add('visible');
    });

    function hideToast(el) {
      clearTimeout(timer);
      el.classList.remove('visible');
      el.classList.add('hide');

      // Remove from DOM after animation ends
      el.addEventListener('transitionend', () => el.remove(), { once: true });
    }

    toast.onclick = () => hideToast(toast);

  // Auto hide after duration
    const timer = setTimeout(() => hideToast(toast), duration);
  }
}

window.Toast = new ToastNotification();

if (typeof window.Toast === 'undefined') {
  window.Toast = new ToastNotification();
}